import type { Entity } from '@backstage/catalog-model';

import { ANNOTATION_SOURCE_LOCATION } from '@backstage/catalog-model';

export const hasChangelogAnnotation = (entity: Entity) => {
  if (entity.metadata.annotations?.['changelog-file-ref']) {
    return true;
  }

  if (
    entity.metadata.annotations?.['changelog-name']
    && entity.metadata.annotations[ANNOTATION_SOURCE_LOCATION]
  ) {
    return true;
  }
  return Boolean(entity.metadata.annotations?.[ANNOTATION_SOURCE_LOCATION]);
};
